import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BbCardModule } from "@features/bb-card";
import { FilterModule } from "@features/filter";
import { GridModule } from "@features/grid";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { PrimeNgModule } from "@primeng";
import { SquadRoutingModule } from "./squad-routing.module";
import { SquadsGridRoutingComponent } from "./squads-grid-routing.component";
import { SquadsGridComponent } from "./squads-grid.component";

@NgModule({
    declarations: [SquadsGridComponent, SquadsGridRoutingComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        BbCardModule,
        FilterModule,
        PrimeNgModule,
        MiproSharedModule,
        SquadRoutingModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [SquadsGridComponent]
})
export class SquadModule {}
